import { render, staticRenderFns } from "./MusicMenu.vue?vue&type=template&id=342c44f2&scoped=true"
import script from "./MusicMenu.vue?vue&type=script&lang=js"
export * from "./MusicMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c44f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('342c44f2')) {
      api.createRecord('342c44f2', component.options)
    } else {
      api.reload('342c44f2', component.options)
    }
    module.hot.accept("./MusicMenu.vue?vue&type=template&id=342c44f2&scoped=true", function () {
      api.rerender('342c44f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stickerMenu/MusicMenu.vue"
export default component.exports